<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import { debug, jobs, planning } from '../../../stores/store';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import SelectHour from '../../shared/SelectHour.svelte';
    import Duration from '../../shared/Duration.svelte';
    import MessageInline from '../../shared/Messages/MessageInline.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { getHumanFriendlyTimeDuration } from '../../utilities/datetime';
    import { onMount } from 'svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import ButtonBack from '../../shared/ButtonBack.svelte';
    import { clientSettings } from '../../../stores/api';

    export let isOpen: boolean = false;
    export let onClick: () => void = () => {};
    export let text: string = '';

    let remainedSeconds: number = 0;

    function getTimeRemainedSeconds(day: string, hour: string): number {
        const now = new Date();
        const date = new Date(day + ' ' + hour);
        const diff = date.getTime() - now.getTime();
        return Math.floor(diff / 1000);
    }

    $: remainedSeconds = getTimeRemainedSeconds($jobs.defaultTargetDate, '23:59');
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <div>{text}</div>
            <div
                style="display: flex; justify-content: center; align-items: center; column-gap: 10px; padding:20px;"
            >
                <SelectDay
                    minDay={new Date().toISOString().substring(0, 10)}
                    showRelativeToday={$clientSettings.display.showRelativeToday}
                    bind:day={$jobs.defaultTargetDate}
                    onChange={d => {
                        console.log('selectedDay', d);
                    }}
                    drops="down"
                />
            </div>

            <div style="height: 30px; display: flex; align-items: center; justify-content: center;">
                {#if remainedSeconds > 0}
                    <MessageInline
                        text={$_('The date will be completed in') +
                            ': ' +
                            getHumanFriendlyTimeDuration(remainedSeconds)}
                    />
                {:else if remainedSeconds <= 0}
                    <ErrorInline
                        text={$_('The specified date cannot be set because it has already passed')}
                    />
                {/if}
            </div>

            <div class="actions">
                <ButtonBack text={$_('Cancel')} showIcon={false} on:click={closeModal} />
                <ButtonMain
                    text={$_('Set target date', {
                        values: { count: $jobs.selectedOrUnselected.length },
                    })}
                    disabled={remainedSeconds <= 0}
                    showIcon={false}
                    on:click={() => {
                        onClick();
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        width: 390px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        align-items: center;
        row-gap: 10px;
        padding-top: 40px;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: flex-end;
        column-gap: 10px;
    }
</style>
